import type React from 'react'

import {
  GridRowItemsStyled,
  MultiGridItemStyled,
  type PaddingBreakpointTypes,
  SingleGridItemStyled,
} from './styles'

interface Props {
  id?: string
  content: React.ReactElement[]
  heights?: string[]
  widthPercentages?: string[]
  isImages?: boolean[]
  hasSideImages?: boolean[]
  paddingBreakpoints?: PaddingBreakpointTypes[]
}

export const BlockSpace: React.FC<Props> = ({
  id,
  content,
  heights = ['auto', 'auto'],
  widthPercentages = ['50%', '50%'],
  isImages = [false, false],
  hasSideImages = [false, false],
  paddingBreakpoints = ['sm', 'sm'],
}) => {
  return (
    <>
      {content.length === 1 ? (
        <SingleGridItemStyled
          height={heights[0]}
          paddingBreakpoint={paddingBreakpoints[0]}
          {...(id && { id })}
        >
          {content[0]}
        </SingleGridItemStyled>
      ) : (
        <GridRowItemsStyled>
          {content.map((element: React.ReactElement, index) => (
            <MultiGridItemStyled
              height={heights[index]}
              image={isImages[index]}
              key={index}
              paddingBreakpoint={paddingBreakpoints[index]}
              sideimage={hasSideImages[index]}
              width={widthPercentages[index]}
            >
              {element}
            </MultiGridItemStyled>
          ))}
        </GridRowItemsStyled>
      )}
    </>
  )
}
